// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7J4lA","colMin":"styles_colMin__30Bt0"};